<template>
  <div id="app" class="m-6 max-w-lg font-serif">
    <h1 class="font-sans text-left mb-6 text-grey-darkest">The Inntopia Email Signature Builder</h1>
    <p
      class="text-grey-darkest"
    >Carefully type your information in on the left, and watch it magically appear in the siganture on the right. Neat!</p>
    <p
      class="text-grey-darkest pt-4"
    >When you're satisfied (I recommend double-checking all the links first), go ahead and hit the "Select & Copy Signature" button at the bottom, and copy/paste that sucker into your email client of choice.</p>
    <p class="my-2">&nbsp;</p>
    <hr>
    <Signature></Signature>
  </div>
</template>

<script>
import Signature from "./components/Signature.vue";

export default {
  name: "app",
  components: {
    Signature
  }
};
</script>

<style>
@import "assets/styles/tailwind.postcss";

#app {
  display: inherit;
}
</style>
